import { defineStore } from 'pinia'
import useSearchStore from './search'

export const useAppStore = defineStore('app', {
  state: () => ({
    // 缓存组件
    catch_components: [],

    // 当前选中的标签 - 默认选择首页
    activeFullPath: '/', // dashboard
    // 当前选中的菜单组
    activeGroup: '',

    // 标签项
    tabList: [
      {
        path: '/dashboard',
        label: 'Operation Figure',
        name: 'dashboard',
        fullPath: '/dashboard',
        group: '',
      },
    ],
  }),

  actions: {
    setGroup(val) {
      this.activeGroup = val
    },

    /**
     * 切换路由更新当前激活标签和标签列表
     * @param {*} submenu 路由信息（要跳转的路由）
     * @param {*} index 当前激活Tab索引（跳转前的tab）
     */
    selectMenu(submenu, index) {
      const activeFullPath = submenu.fullPath
      const activeGroup = submenu.group

      const newTabList = this.tabList

      // 将Tab信息添加到tabList - 添加时判断是否已有该路由
      const result = newTabList.some(
        (item) => item.fullPath === submenu.fullPath
      )
      if (!result) {
        const newRouteInfo = {
          path: submenu.path,
          name: submenu.name,
          label: submenu.label || submenu.name,
          fullPath: submenu.fullPath,
          group: submenu.group,
          canEdit: submenu.canEdit,
        }
        // 保证新开窗口在当前窗口后面一个位置
        newTabList.splice(index + 1, 0, newRouteInfo)
      }

      // 重新赋值标签路由和当前选中标签
      this.activeFullPath = activeFullPath
      this.activeGroup = activeGroup
      this.tabList = newTabList

      // todo 可以将useNavigation中的current和currentTab放到全局维护
    },

    // 添加keepalive缓存
    addKeepAliveCache(val) {
      // 如果是首页不缓存
      if (val === 'dashboard') {
        return
      }
      if (this.catch_components.indexOf(val) === -1) {
        // 不存在，缓存页面
        this.catch_components.push(val)
      }
    },

    // 删除keepalive缓存
    removeKeepAliveCache(val) {
      const cache = this.catch_components
      for (let i = 0; i < cache.length; i++) {
        if (cache[i] === val) {
          cache.splice(i, 1)
        }
      }
      this.catch_components = cache
    },

    // 清空路由信息
    clearAppInfo() {
      this.catch_components = []
      this.activeFullPath = '/'
      this.activeGroup = ''
      this.tabList = [
        {
          path: '/dashboard',
          label: 'Operation Figure',
          name: 'dashboard',
          fullPath: '/dashboard',
          group: '',
        },
      ]
    },

    // 关闭标签
    closeTab(val) {
      // 重新赋值
      this.activeFullPath = val.activeFullPath
      this.tabList = val.tabList
    },
    // todo 关闭标签时1.清除缓存2.编辑页先弹窗提示是否关闭
    // 关闭其他标签页
    closeOtherTab(index) {
      const newTab = this.tabList[index]
      this.activeFullPath = newTab.fullPath
      this.tabList = [newTab]
    },
    // 关闭右侧标签页
    closeRightTab(index) {
      const newTabList = this.tabList.filter((item, indexX) => index >= indexX)
      this.tabList = [...newTabList]
    },
    // 关闭左侧标签页
    closeLeftTab(index) {
      const newTabList = this.tabList.filter((item, indexX) => index <= indexX)
      this.tabList = [...newTabList]
    },
    // 移除指定tab
    removeTab(path) {
      const newTabList = this.tabList.filter((item) => item.fullPath !== path)
      this.tabList = newTabList
    },
    // 切换激活页面
    changeMenu(val) {
      this.activeFullPath = val.fullPath
      this.activeGroup = val.group
    },
  },
  persist: {
    enabled: true,
  },
})

export const useUserStore = defineStore('user', {
  state: () => ({
    loadStatus: 'IDLE', // 系统认证状态  IDLE ：未认证, LOADING ：认证中, SUCCEEDED ：认证成功, FAILED ：认证失败, EXPIRES:认证过期
    // 树形菜单权限
    treeMenuPermissions: [],
    // 菜单权限（code,name）
    menuPermissions: [],
    // 权限菜单-只包含name
    menuPermissionNames: [],

    // 按钮权限
    buttonPermissions: [], // 'TRIBE_EDIT', 'CAMPAIGN_EDIT', 'PGC_EDIT'
    // 用户信息
    userInfo: {
      wiwId: 'mocker',
      email: 'mocker@gmail.com',
      username: 'mocker',
      isSystemAdmin: true,
    },
    token: '', // 用户token
  }),

  actions: {
    updateLoadStatus(status) {
      this.loadStatus = status
    },

    updateUserInfo(sysInfo) {
      this.menuPermissions = sysInfo.menuPermissions
      this.buttonPermissions = sysInfo.buttonPermissions
      this.userInfo = sysInfo.user
      this.token = sysInfo.token
    },
    clearUserInfo() {
      this.loadStatus = 'IDLE'
      this.treeMenuPermissions = []
      this.menuPermissions = []
      this.buttonPermissions = []
      this.token = ''
      // this.userInfo = {
      //   wiwId: 'mocker',
      //   email: 'mocker@gmail.com',
      //   username: 'mocker',
      //   isSystemAdmin: true,
      // }
    },
    filterMenu(routeArr) {
      this.treeMenuPermissions = []
      let roleMenuList = []
      const groupObj = {}
      const sortObj = {}
      const menuPermissionList = this.menuPermissions.map((item) => item.code)
      roleMenuList = routeArr.filter((item) => {
        if (item?.meta?.group) {
          groupObj[item?.meta?.group] = []
        }
        if (item?.meta?.groupSort && !sortObj[`${item?.meta?.group}Sort`]) {
          sortObj[`${item?.meta?.group}Sort`] = item?.meta?.groupSort
        }

        if (item.authed) {
          return menuPermissionList.includes(item.authed.toLocaleUpperCase())
        }

        return false
      })
      roleMenuList.forEach((item) => {
        for (const i in groupObj) {
          if (item?.meta?.group === i) {
            groupObj[item?.meta?.group].push(item)
          }
        }
      })
      Object.keys(groupObj).forEach((key) => {
        if (groupObj[key].length > 0) {
          this.treeMenuPermissions.push({
            name: key,
            children: groupObj[key],
            sort: sortObj[`${key}Sort`],
          })
        }
      })
      this.treeMenuPermissions.sort((a, b) => a.sort - b.sort)

      // 路由白名单
      const whiteList = ['error-404', 'error-403', 'error-401']

      const treeMenuPermissionNames = this.treeMenuPermissions.flatMap((item) =>
        item.children.map((i) => i.name)
      )

      this.menuPermissionNames = [...treeMenuPermissionNames, ...whiteList]
    },
  },
  persist: {
    enabled: true,
  },
})

export const searchStore = useSearchStore
